// @flow
import React, { useState, useEffect } from 'react';

import type { FiveSymbolLocale } from '#common/utils/locale';
import type { IUserAccountService } from '../../../../scripts/blocks/login/user-account-services';
import type { ILayoutEnum } from '../layout';

import { useOuterClick } from '../../../../utils/hooks/useOuterClick';
import { sendClick, XAEvents } from '../../../../utils/init-xsolla-analytics';
import LoggedUser from '../LoggedUser';
import LoginButton from '../LoginButton';
import LogoutButton from '../LogoutButton';
import UserBalance from '../UserBalance';

import './style.pcss';

type Props = {|
  onLoginClick: () => void,
  locale: FiveSymbolLocale,
  merchantId: string,
  layout: ILayoutEnum,
  userService: IUserAccountService,
  isExperimentalFeature?: boolean,
|};

export const UserAccount = ({
  onLoginClick,
  locale,
  merchantId,
  layout,
  userService,
  isExperimentalFeature,
}: Props) => {
  const [isShowLogout, setShowLogout] = useState(false);
  const handleCloseLogout = () => setShowLogout(false);

  const onLoggedUserClick = () => {
    if (!isExperimentalFeature) {
      setShowLogout(!isShowLogout);
      sendClick(merchantId, XAEvents.clickOnUserAccount);
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (userService?.isAuthorized) {
      document.addEventListener('keydown', handleCloseLogout);
      return () => {
        document.removeEventListener('keydown', handleCloseLogout);
      };
    }
    handleCloseLogout();
  }, [userService?.isAuthorized]);

  const logoutRef = useOuterClick(() => {
    if (userService?.isAuthorized && isShowLogout) {
      handleCloseLogout();
    }
  });

  const onLogout = () => {
    userService.logOut();
    handleCloseLogout();
    sendClick(merchantId, XAEvents.clickOnLogout);
  };

  return (
    <>
      {!userService?.isAuthorized
        ? (
          <LoginButton
            onClick={onLoginClick}
            locale={locale}
          />
        ) : (
          <>
            <button
              className={`header-user-account header-user-account-${layout}`}
              onClick={onLoggedUserClick}
            >
              <LoggedUser
                layout={layout}
                picture={userService?.picture}
                text={userService?.userName}
              />
              <UserBalance
                layout={layout}
                balance={userService?.balance}
              />
            </button>
            <div
              className='header-user-account__logout'
              ref={logoutRef}
            >
              <LogoutButton
                layout={layout}
                locale={locale}
                onClick={onLogout}
                isShow={isShowLogout}
              />
            </div>
          </>
        )}
    </>
  );
};
